// removed by extract-text-webpack-plugin
module.exports = {"fontLoaded":"rA-BJ-W6"};


//////////////////
// WEBPACK FOOTER
// ./client/components/App.styl
// module id = 596
// module chunks = 0